import React from 'react';

const variantClasses = {
  default: 'bg-blue-600 text-white border-transparent',
  secondary: 'bg-slate-100 text-slate-700 border-slate-200',
  outline: 'bg-transparent text-slate-700 border-slate-300',
  destructive: 'bg-red-600 text-white border-transparent',
};

export function Badge({ variant = 'default', className = '', children, ...rest }) {
  const base =
    'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium leading-tight';
  return (
    <span className={`${base} ${variantClasses[variant] || ''} ${className}`} {...rest}>
      {children}
    </span>
  );
}

export default Badge;
